import { UNAUTHENTICATED_PATHS } from '../../../CspPath';
import { useMatchPaths } from './useMatchPaths';

export const useIsUnauthenticatedRoute = (): boolean => Boolean(useMatchPaths(UNAUTHENTICATED_PATHS));
